export default __webpack_public_path__ + "static/media/tttt.9ff0fe89.svg";